module.exports = __webpack_public_path__ + "img/164.bf31bed8.jpg";